<template>
  <div class="content">
    <el-tabs v-model="activeName">
      <el-tab-pane label="RX国际" name="first">
        <RX></RX>
      </el-tab-pane>
      <el-tab-pane label="ZY国际" name="second">
        <ZY></ZY>
      </el-tab-pane>
      <el-tab-pane label="BX国际" name="third">
        <BX></BX>
      </el-tab-pane>
      <el-tab-pane label="QC国际" name="four">
        <QC></QC>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import ZY from "./source/ZY.vue"
import BX from "./source/BX.vue"
import RX from "./source/RX.vue"
import QC from "./source/QC.vue"
export default {
  name: "internationalChnanel",
  data() {
    return {
      activeName: "four",
    };
  },
  components: {
    ZY,
    BX,
    RX,
    QC
  },
  created() {
  },
};
</script>